import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SessionService } from './core/session/session.service';
import { TimeTrackingService } from './core/time-tracking/time-tracking.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`
})
export class App {
  private readonly session = inject(SessionService);
  private readonly timeTracking = inject(TimeTrackingService);

  constructor() {
    this.session.start();
    this.timeTracking.hydrate();
  }
}
